import chalk from 'chalk';

import type { SemTree } from 'semtree';

import { buildTreeSync, type InitTree, type Node } from '../util/tree';
import { getFileNames } from '../util/util';


// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function tree(payload: InitTree, opts: any) {
  const semtree: SemTree | undefined = buildTreeSync(payload);
  if (!semtree) {
    console.error(chalk.red('unable to build tree'));
    return;
  }
  const branches: string[] = semtree.branches;
  console.log(printTree(semtree.root, semtree.nodes));

  // helper function to render tree
  function printTree(curNodeName: string, nodes: Node[], prefix: string = ''): string {
    let printedTree: string;
    const isBranchFile: boolean = branches.includes(curNodeName);
    const isLeafFile: boolean = !branches.includes(curNodeName) && getFileNames().includes(curNodeName);
    //const isZombieFile: boolean = (!isIndexFile && !isLeafFile)
    if (isBranchFile) {
      // branch case
      printedTree = chalk.yellow(curNodeName + '\n');
    } else if (isLeafFile) {
      // leaf case
      printedTree = chalk.green(curNodeName + '\n');
    } else {
      // zombie case
      printedTree = chalk.dim(curNodeName + '\n');
    }
    const node: Node | undefined = nodes.find((node: Node) => node.text === curNodeName);
    if (node === undefined) { return printedTree; }
    node.children.forEach((child: string, index: number) => {
      const isLastChild: boolean = (index === node.children.length - 1);
      const childPrefix: string = prefix + (isLastChild ? chalk.yellow('└── ') : chalk.yellow('├── '));
      const grandchildPrefix: string = prefix + (isLastChild ? '    ' : chalk.yellow('|   '));
      const subtree: string = printTree(child, nodes, grandchildPrefix);
      printedTree += childPrefix + subtree;
    });
    return printedTree;
  }
}
